import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { toCurrency } from 'utilities/currency';
import { getSoftwarePriceLabel } from 'utilities/software';

const CartItem = ({
  productName,
  serialNumber,
  quantity,
  cost,
  currency,
  plan,
  isSoftware,
}) => {
  const { t } = useTranslation();

  return (
    <Grid container mb={0.5}>
      <Grid
        item
        container
        xs={12}
        spacing={1}
        style={{ marginTop: 0, marginBottom: 0 }}
      >
        {!isSoftware && (
          <Grid item>
            <p className="paragraph-20">{`${quantity} x`}</p>
          </Grid>
        )}
        <Grid item xs style={{ flexGrow: 1 }}>
          <p className="paragraph-20">{productName}</p>
        </Grid>
        <Grid item style={{ marginLeft: 'auto' }}>
          <p className="paragraph-20">
            {isSoftware
              ? getSoftwarePriceLabel({ plan, t })
              : toCurrency(cost, currency)}
          </p>
        </Grid>
      </Grid>
      {serialNumber && (
        <Grid item xs={12}>
          <p className="paragraph-20" style={{ color: 'rgba(0,0,0,0.65)' }}>
            {t('checkout.receipt.label.replacementForSN', { serialNumber })}
          </p>
        </Grid>
      )}
    </Grid>
  );
};

export default CartItem;
